"use client"

import { useEffect, useState } from "react"

import { UserPopups } from "@bullseye/components"

import { ApplicationModal, useApplicationModalContext } from "../../components"

export const useEventAttendanceCapture = (userPopups: UserPopups) => {
  const { openModal } = useApplicationModalContext()
  const [hasOpenedModal, setHasOpenedModal] = useState(false)

  useEffect(() => {
    if (!userPopups?.experienceAttendance?.length || hasOpenedModal) {
      return
    }
    if (
      !userPopups?.experienceAttendance ||
      userPopups.experienceAttendance.length === 0
    ) {
      return
    }

    openModal(ApplicationModal.EventAttendance, {
      experiences: userPopups.experienceAttendance,
    })
    setHasOpenedModal(true)
  }, [userPopups, openModal])
}
